module.exports = __webpack_public_path__ + "assets/img/zrdq.50f4d00f.png";